/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ method: NonNullable<unknown>, url: NonNullable<unknown> }} Seo_Endpoint_A_CallInputs */

const en_seo_endpoint_a_call = /** @type {(inputs: Seo_Endpoint_A_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Send a ${i?.method} request to ${i?.url} with your AnyAPI key in an "Authorization: Bearer" header and the input as a JSON body. The same key and the same wallet work on every AnyAPI endpoint.`)
};

const zh_hans1_seo_endpoint_a_call = /** @type {(inputs: Seo_Endpoint_A_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`向 ${i?.url} 发送 ${i?.method} 请求，在 “Authorization: Bearer” 请求头中放入你的 AnyAPI 密钥，并以 JSON 请求体传入参数。同一个密钥和同一个钱包适用于所有 AnyAPI 接口。`)
};

const pt_br2_seo_endpoint_a_call = /** @type {(inputs: Seo_Endpoint_A_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Envie uma requisição ${i?.method} para ${i?.url} com sua chave da AnyAPI em um cabeçalho "Authorization: Bearer" e a entrada como corpo JSON. A mesma chave e a mesma carteira funcionam em todos os endpoints da AnyAPI.`)
};

const es_seo_endpoint_a_call = /** @type {(inputs: Seo_Endpoint_A_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Envía una solicitud ${i?.method} a ${i?.url} con tu clave de AnyAPI en un encabezado "Authorization: Bearer" y la entrada como cuerpo JSON. La misma clave y la misma billetera sirven para todos los endpoints de AnyAPI.`)
};

const fr_seo_endpoint_a_call = /** @type {(inputs: Seo_Endpoint_A_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Envoyez une requête ${i?.method} à ${i?.url} avec votre clé AnyAPI dans un en-tête « Authorization: Bearer » et l’entrée en corps JSON. La même clé et le même portefeuille fonctionnent sur tous les endpoints AnyAPI.`)
};

const de_seo_endpoint_a_call = /** @type {(inputs: Seo_Endpoint_A_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sende eine ${i?.method}-Anfrage an ${i?.url} mit deinem AnyAPI-Schlüssel in einem Header „Authorization: Bearer“ und der Eingabe als JSON-Body. Derselbe Schlüssel und dasselbe Guthabenkonto funktionieren bei jedem AnyAPI-Endpoint.`)
};

const ru_seo_endpoint_a_call = /** @type {(inputs: Seo_Endpoint_A_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отправьте запрос ${i?.method} на ${i?.url} с вашим ключом AnyAPI в заголовке "Authorization: Bearer" и входными данными в теле JSON. Один и тот же ключ и один и тот же кошелёк работают на каждом эндпоинте AnyAPI.`)
};

const it_seo_endpoint_a_call = /** @type {(inputs: Seo_Endpoint_A_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invia una richiesta ${i?.method} a ${i?.url} con la tua chiave AnyAPI in un header "Authorization: Bearer" e l'input come corpo JSON. La stessa chiave e lo stesso portafoglio funzionano su ogni endpoint AnyAPI.`)
};

/**
* | output |
* | --- |
* | "Send a {method} request to {url} with your AnyAPI key in an \"Authorization: Bearer\" header and the input as a JSON body. The same key and the same wallet wor..." |
*
* @param {Seo_Endpoint_A_CallInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_a_call = /** @type {((inputs: Seo_Endpoint_A_CallInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_A_CallInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_a_call(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_a_call(inputs)
	if (locale === "es") return es_seo_endpoint_a_call(inputs)
	if (locale === "fr") return fr_seo_endpoint_a_call(inputs)
	if (locale === "de") return de_seo_endpoint_a_call(inputs)
	if (locale === "ru") return ru_seo_endpoint_a_call(inputs)
	if (locale === "it") return it_seo_endpoint_a_call(inputs)
	return en_seo_endpoint_a_call(inputs)
});